import { Link } from "react-router-dom";


const Adminchargesmain = () => {
  return (
    <section>
      <div className="container-fluid">
        <div className="row">
          

          <div className="col-lg-10 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-1 text-end">
                <Link to="/">
                  <h6>
                    <i class="fa fa-home" aria-hidden="true"></i>Home
                  </h6>
                </Link>
              </div>
              /
              <div className="col-lg-5">
                <h6> Admin Charges Details</h6>
              </div>
            </div>

            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>Admin Charges Details</h4>
              </div>

              <div className="card-body text-center">
                <div className="col-lg-12 ">
                  <div className="row ">
                    {/* =======================Basic Admin Charges Details start================= */}

                    {/* <div className="col-lg-4 border border-0 rounded-3 mt-3">
                      <div className="card bg bg-warning">
                        <div className="card-body">
                          <h5 className="mt-2">Basic Admin Charges Details</h5>
                          <h2 className="mt-2">
                            <i className="fa fa-eye" aria-hidden="true"></i>
                            9,567
                          </h2>

                          <Link
                            to="/BasicAdminCharges"
                            className="btn btn-danger btn-sm mt-2 mb-2"
                          >
                            Click here
                          </Link>
                        </div>
                      </div>
                    </div> */}

                    {/* =======================Basic Admin Charges Details end================= */}

                    {/* ====================Premium Admin Charges Details start==================== */}

                    <div className="col-lg-4 border border-0 rounded-3 mt-3">
                      <div className="card bg bg-warning">
                        <div className="card-body">
                          <h5 className="mt-2">
                            Premium Admin Charges Details
                          </h5>
                          <h2 className="mt-2">
                            <i className="fa fa-eye" aria-hidden="true"></i>
                            9,567
                          </h2>

                          <Link
                            to="/PremiumAdminCharges"
                            className="btn btn-danger btn-sm mt-2 mb-2"
                          >
                            Click here
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* ====================Premium Admin Charges Details end==================== */}

                    {/* ====================Repurchased Admin Income start==================== */}

                    <div className="col-lg-4 border border-0 rounded-3 mt-3">
                      <div className="card bg bg-warning">
                        <div className="card-body">
                          <h5 className="mt-2">Repurchased Admin Income</h5>
                          <h2 className="mt-2">
                            <i className="fa fa-eye" aria-hidden="true"></i>
                            9,567
                          </h2>

                          <Link
                            to="/Reparchaseclick"
                            className="btn btn-danger btn-sm mt-2 mb-2"
                          >
                            Click here
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* ====================Repurchased Admin Income end==================== */}

                    {/* ====================Vendor Admin Charges start==================== */}

                    <div className="col-lg-4 border border-0 rounded-3 mt-3">
                      <div className="card bg bg-warning">
                        <div className="card-body">
                          <h5 className="mt-2">Vendor Admin Charges</h5>
                          <h2 className="mt-2">
                            <i className="fa fa-eye" aria-hidden="true"></i>
                            9,567
                          </h2>

                          <Link
                            to="/vendorAdminclick"
                            className="btn btn-danger btn-sm mt-2 mb-2"
                          >
                            Click here
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* ====================Vendor Admin Charges end==================== */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Adminchargesmain;
